
import { Vue, Component, Prop } from "vue-property-decorator";
import VisitsListCard from "@/components/projects/VisitsCard.vue";
import { Project_Activity, User } from "@/generated/graphql";
import CardsContainer from "@/components/card/CardsContainer.vue";
import ElementsSizeProvider from "@/components/uiSize/ElementsSizeProvider.vue";

@Component({
  components: {
    ElementsSizeProvider,
    CardsContainer,
    VisitsListCard,
  },
})
export default class VisitsCardWrapper extends Vue {
  @Prop({ type: Array, required: true })
  readonly activities!: Project_Activity[];
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: Function, required: false })
  readonly getDeclinedMatchesForActivity!: (activityId: string) => any[];
  @Prop({ type: Function, required: false })
  readonly getBookmarkedContractorsForActivity!: (activityId: string) => any[];

  visitUpdated(): void {
    this.$emit("visitUpdated");
  }
}
